import { useMutationCallbacks } from '@feedback/relay';
import { useTranslation } from 'react-i18next';

import {
  postFile, 
  secureFile,
  FILE_TYPES,
  findHeaders,
  generateHeader,
} from '@feedback/upload';

import { PreSignedFileUploadMutation } from './PreSignedFileUploadMutation';

type UseUploadExecute = {
  file: File;
};

type UseUpload = {
  fileType: string;
  headerType: string;
};
export const useUpload = ({ fileType, headerType }: UseUpload) => {
  const { t } = useTranslation();

  const errorPreSigned = t('Error uploading file');

  const [preSignedFileUpload] = useMutationCallbacks({
    name: 'PreSignedFileUpload',
    mutation: PreSignedFileUploadMutation,
  });

  // TODO - move headerType to execute
  const execute = ({ file }: UseUploadExecute) => {
    return new Promise((resolve) => {
      let blob = file || null;

      // file can be related to a id
      if (!blob) {
        const control = document.getElementById('file');
        const files = control && control.files;
        blob = files && files[0];
      }

      if (!blob) {
        resolve({ error: 'Invalid file' });
      }

      const fileReader = new FileReader();
      fileReader.onloadend = async (element) => {
        const header = generateHeader(element?.target?.result);
        // eslint-disable-next-line
        console.log('header', header);

        if (!Object.keys(FILE_TYPES).includes(headerType)) {
          resolve({ error: 'Invalid header type' });
        }

        const headers = findHeaders(headerType);

        if (headers.indexOf(header) > -1) {
          const securedFile = secureFile(blob);

          const config = {
            variables: {
              input: {
                type: fileType,
                contentType: blob.type,
              },
            },
            onCompleted: ({ PreSignedFileUpload }) => {
              resolve(postFile(PreSignedFileUpload, securedFile));
            },
            onError: (error) => {
              resolve({ error: error || errorPreSigned });
            },
          };

          preSignedFileUpload(config);
        } else {
          resolve({ error: 'Tipo de arquivo não suportado' });
        }
      };

      blob && fileReader.readAsArrayBuffer(blob);
    });
  };

  return [execute];
};
